import Icon from '../components/Icon.vue'

Icon.register({
  'satellite-dish': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M188.8 345.9l116.6 116.6c7.4 7.3 6.2 20.1-3 25-77.7 41.8-176.7 29.9-242.3-35.7-65.6-65.6-77.5-164.5-35.7-242.3 4.9-9.1 17.7-10.3 25-3l116.8 116.8 27.4-27.4c-0.7-2.6-1.6-5-1.6-7.8 0-17.7 14.3-32 32-32s32 14.3 32 32c0 17.7-14.3 32-32 32-2.8 0-5.2-0.9-7.8-1.6zM209 0c163.2 8.6 294.4 139.8 302.9 303 0.5 9.2-6.8 17-16 17h-32.1c-8.4 0-15.4-6.6-15.9-15-7.5-129.5-111.5-234.5-240.9-241.5-8.4-0.4-15-7.4-15-15.9v-31.6c0-9.2 7.8-16.5 17-16zM209.3 96c110.1 8.5 198.2 96.6 206.6 206.7 0.7 9.3-6.8 17.3-16.1 17.3h-32.2c-8.3 0-15.1-6.4-15.9-14.7-6.9-77-68.1-138.9-144.9-145.2-8.3-0.6-14.8-7.5-14.8-15.9v-32.1c0-9.4 8-16.8 17.3-16.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/satellite-dish.js
// module id = 1858
// module chunks = 0